<template>
  <div class="message-center">
    <el-tabs
      v-model="formSearch.msgClass"
      @tab-click="onChangeTab"
    >
      <el-tab-pane
        v-for="(item,index) in typeData"
        :key="index"
        :name="item.value"
        :label="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div class="table-container">
      <div class="header">
        <div class="search-content">
          <el-form @submit.native.prevent>
            <el-form-item style="float:left;">
              <el-radio-group
                v-model="formSearch.isRead"
                @change="onPageChange({page:1})"
              >

                <el-radio-button label="">{{ $t('com_all') }}</el-radio-button>
                <el-radio-button
                  v-for="(item, index) in dicMap.is_read"
                  :key="index"
                  :label="item.value"
                >{{ item.name }} {{item.code==='not_read'? msgCount.unReadCounts.totalCounts:''}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item style="float: right; margin-right: 0">
              <div
                class="filter"
                @click="showFilter"
              >
                <i class="icon icon-shaixuan1"></i>
              </div>
            </el-form-item>
            <el-form-item style="float: right; ">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float:right;">
              <search-input
                v-model="formSearch.keyword"
                :placeholder="$t('com_please_input')"
                @input="onKeywordChange"
              ></search-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('message_center_shai_xuan_xiang') }}：</div>
        <div class="values">
          <el-tag
            closable
            v-for="tag in msgTypeTagList"
            :key="tag.value"
            @close="onCloseMsgType()"
          >{{tag.label}}</el-tag>
          <el-tag
            closable
            v-for="dateTag in dateTagList"
            :key="dateTag.value"
            @close="onCloseTime()"
          >{{dateTag.label}}</el-tag>
          <el-tag
            closable
            v-for="tag in keywordTagList"
            :key="tag.value"
            @close="onCloseKeyword(tag.value)"
          >{{tag.label}}</el-tag>
          <el-button
            type="info"
            size="mini"
            @click="onClear"
          >{{ $t('com_clear') }}</el-button>
        </div>
      </div>
      <div class="table-bd">
        <custom-table
          v-model="selectedData"
          :tableCode="tableCode"
          type="checkbox"
          height="100%"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          :slots="['content','action']"
          @filter="filterChange"
          @sort="sortChange"
        >
          <template v-slot:content="scope">
            <div class="msg-content">{{scope.row.content}}</div>
          </template>
          <template v-slot:action="scope">
              <el-button
                type="text"
                size="mini"
                v-if="!scope.row.isRead && funcView.message_mark_read"
                @click="onMarkRead(scope.row)"
              >{{ $t('message_center_biao_ji_yi_du') }}</el-button>
              <el-button
                v-if="funcView.message_del"
                type="text"
                size="mini"
                @click="onDelMsg(scope.row)"
              >{{ $t('com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
          radius
        >
          <div
            class="mark-all"
            slot="totalNumAppend"
          >
            <el-button
              v-if="funcView.message_mark_read"
              type="text"
              size="mini"
              @click="onMarkAllRead"
              :disabled="!tableList.length"
            >{{ $t('message_center_quan_bu_yi_du') }}</el-button>
          </div>
        </custom-pagination>

      </div>
    </div>
    <msg-filter-dialog
      v-if="msgFilterVisible"
      @close="msgFilterVisible = false"
      :model="msgFilterModal"
      :msgTypeList="msgTypeList"
      @confirm="onMsgFilterConfirm"
    ></msg-filter-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import msgFilterDialog from './children/msg_filter_dialog.vue';

// message_center_shai_xuan_xiang: 筛选项// message_center_biao_ji_yi_du: 标记已读// message_center_quan_bu_yi_du: 全部已读// message_center_shai_xuan: 筛选// message_center_nqdyscsxdxxm: 您确定要删除所选的消息吗？// message_center_nqdyjsxdxxbjwydm: 您确定要将所选的消息标记为已读吗？// message_center_nqdyjsyxxbjwydm: 您确定要将所有消息标记为已读吗？

export default {
  name: '',
  mixins: [],
  components: {
    msgFilterDialog
  },
  props: {
  },
  data() {
    return {
      tableCode: 'portal_msg_center',

      type: '',
      dicMap: {},

      msgCount: {},
      msgClass: [],
      isRead: 'all',

      formSearch: {
        keyword: '',
        pageSize: 50,
        pageNum: 1,
        msgClass: '',
        msgType: '',
        isRead: '',
        sendTime: ''
      },
      totalRows: 0,
      tableList: [
      ],
      selectedData: [],
      typeData: [],
      msgFilterVisible: false,
      msgFilterModal: {},
      keywordTagList: [],
      dateTagList: [],
      msgTypeTagList: [],
    };
  },
  computed: {
    msgTypeList() {
      const item = this.formSearch.msgClass;
      const row = this.dicMap.bas_msg_class.find(t => t.value === item);
      const ret = row ? row.children : [];
      return ret;
    },
    // markReadVisible() {
    //   const list = this.tableList;
    //   if (!list || !list.length) {
    //     return false;
    //   }
    //   return !list.some(item => !item.isRead);
    // }
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    syncMsgTypeTagList() {
      const msgType = this.formSearch.msgType;
      const msgTypeList = this.msgTypeList;
      if (msgType) {
        if (msgTypeList.length) {
          const item = msgTypeList.find(obj => obj.value === msgType);
          this.msgTypeTagList = [
            {
              label: item.name,
              value: item.value
            }
          ];
        }
      } else {
        this.msgTypeTagList = [];
      }
    },
    syncDateTagList() {
      const data = this.formSearch.sendTime;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.dateTagList = [
          {
            label: `${start}-${end}`,
            value: 'date'
          }
        ];
      } else {
        this.dateTagList = [];
      }
    },
    onCloseTime() {
      this.formSearch.sendTime = [];
      this.onDateChange();
    },
    onDateChange() {
      const data = this.formSearch.sendTime;
      if (data && data.length) {
        const start = data[0];
        const end = data[1];
        this.dateTagList = [
          {
            label: `${start}-${end}`,
            value: 'date'
          }
        ];
      } else {
        this.dateTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseMsgType() {
      this.formSearch.msgType = '';
      this.msgTypeTagList = [];
      this.onPageChange({ page: 1 });
    },
    onKeywordChange() {
      const keyword = this.formSearch.keyword.trim();
      if (keyword) {
        this.keywordTagList = [
          {
            label: keyword,
            value: 'keyword'
          }
        ];
      } else {
        this.keywordTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseKeyword() {
      this.formSearch.keyword = '';
      this.onKeywordChange();
    },
    onChangeTab() {
      this.formSearch.msgType = '';
      this.formSearch.sendTime = [];
      this.onPageChange({ page: 1 });
    },
    onMsgFilterConfirm(data) {
      this.$setFormatData(this.formSearch, data);
      this.syncDateTagList();
      this.syncMsgTypeTagList();

      this.onPageChange({ page: 1 });
    },
    initTypeData() {
      const ret = [
        {
          name: this.$t('com_all'),
          value: '0'
        }
      ];
      const dicArr = this.dicMap.bas_msg_class;
      if (dicArr && dicArr.length) {
        dicArr.forEach((item) => {
          if (this.msgClass[item.value] !== undefined) {
            ret.push(item);
          }
        });
      }
      this.typeData = ret;
    },
    showFilter() {
      this.msgFilterModal = {
        title: this.$t('message_center_shai_xuan'),
        data: this.formSearch
      };
      this.msgFilterVisible = true;
    },
    onClear() {
      this.keywordTagList = [];
      this.dateTagList = [];
      this.msgTypeTagList = [];
      this.$setFormatData(this.formSearch, {
        keyword: '',
        msgType: '',
        sendTime: [],
        pageSize: 50,
        pageNum: 1,
      });
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getReqData() {
      const ret = {
        ...this.formSearch
      };

      if (ret.msgClass === '0') {
        ret.msgClass = '';
      }

      return ret;
    },
    // 消息列表
    getTableList() {
      const reqData = this.getReqData();
      this.$getJSON(apis.msgRecordPage, reqData).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
        this.getMsgCount();
      });
    },
    // 获取消息统计
    getMsgCount() {
      this.$getJSON(apis.msgRecordTotalInit).then((res) => {
        this.msgCount = res.data;
      });
    },
    // 获取当前账号分类 (左上角)
    getMsgClass: function () {
      return this.$getJSON(apis.msgRecordClassList).then((res) => {
        this.msgClass = res.data;
      });
    },
    // 删除消息
    onDelMsg(row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      this.$showConfirm(this.$t('message_center_nqdyscsxdxxm')).then(() => {
        const ids = rows.map(i => i.messageId);
        this.$postJSON(apis.msgRecordDelete, ids).then(() => {
          this.$message({
            message: this.$t('com_delete_success'),
            type: 'success'
          });
          // 更新
          this.getTableList();
        });
      });
    },
    // 标记已读
    onMarkRead(row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      this.$showConfirm(this.$t('message_center_nqdyjsxdxxbjwydm'))
        .then(() => {
          const ids = rows.map(i => i.messageId);
          this.$postJSON(apis.msgRecordRead, ids).then(() => {
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success'
            });
            // 更新
            this.getTableList();
          });
        });
    },
    // 标记全部已读
    onMarkAllRead() {
      this.$showConfirm(this.$t('message_center_nqdyjsyxxbjwydm'))
        .then(() => {
          this.$postJSON(apis.msgRecordReadAll).then(() => {
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success'
            });
            // 更新
            this.getTableList();
          });
        });
    }
  },
  created() {
  },
  mounted() {
    this.mergeLanguage(null, 'portal_messageCenter');
    this.getFuncView();
    this.getDictionary('bas_msg_class,is_read', () => {
      this.getMsgClass().then(() => {
        this.initTypeData();

        const item = this.typeData[0];
        this.formSearch.msgClass = item.value;
        this.getMsgCount();
        this.getTableList();
      });
    }, 'dicMap');
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/colors.scss';
.message-center {
  padding: 24px;

  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 20px 0 0 20px;
  }

  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 20px 20px 0;
  }

  .msg-content {
    word-break: break-all;
    white-space: normal;
  }

  .action-content {
    display: inline-block;
    width: 100%;

    .el-button {
      float: right;
      margin-right: 24px;
    }
  }

  .el-form-item {
    margin-right: 16px;
    margin-bottom: 0;
  }

  .filter-values {
    overflow: hidden;
    margin-top: 14px;
    .label {
      float: left;
      margin-top: 10px;
      line-height: 30px;
      font-size: 12px;
      color: #4d4d4d;
    }
    .values {
      overflow: hidden;
      padding-left: 16px;

      .el-tag {
        border-radius: 15px;
        height: 30px;
        line-height: 30px;
        background-color: #f8f8f8;
        margin-top: 10px;
        border: none;
        color: #1a1a1a;
        padding: 0 16px;
        font-weight: bold;
        margin-right: 16px;

        /deep/ .el-icon-close {
          font-size: 16px;
          font-weight: bold;
          top: 0px !important;
        }
      }
      .el-button {
        padding-top: 8px !important;
        padding-bottom: 8px !important;
        margin-top: 10px;
        border-width: 1px !important;
      }
      .clear {
        background: $--color-warning;
        border-radius: 15px;
        border: none;
        width: 52px;
        text-align: center;
        color: $--color-text-primary;
        font-weight: bold;
        margin-top: 10px;
        display: inline-block;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        padding: 0 14px;
        cursor: pointer;
      }
    }
  }
}

.table-container {
  border-radius: 16px;
  background: #fff;
  width: 100%;

  padding: 24px;
  padding-bottom: 0;

  .search-content {
    overflow: hidden;

    .filter {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      box-shadow: 0 0 0 1.5px #202945 inset;
      line-height: 40px;
      text-align: center;
      .icon {
        font-size: 16px;
        color: #202945;
      }
    }
  }

  .table-bd {
    height: 450px;
    margin-top: 24px;
  }

  .page-footer {
    position: relative;
    .custom-pagination {
      position: relative;
      z-index: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .mark-all {
      height: 40px;
      line-height: 40px;
      color: #00a0d9;
      font-size: 14px;
      cursor: pointer;
      float: left;
      margin-left: 24px;
    }
  }
}
</style>
